<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>
<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProviderParams]="params" [dataProvider]="frontendErrorService"
              [title]="'Error'" [searchColumns]="searchColumns" [searchAll]="true"></data-table>
</page-content>
